export default "__VITE_ASSET__ByLsdNlr__"